import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { injectNavigator } from "utils/navigation";

const NavigationBridge = () => {
  const navigate = useNavigate();

  useEffect(() => {
    injectNavigator(navigate);

    return () => injectNavigator(null);
  }, [navigate]);

  return null;
};

export default NavigationBridge;
